import { StaffPayScaleInput } from '../../lib/types/models/staff-pay-scale/staff-pay-scale-input'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateStaffPayScale(data: UpdateInput<StaffPayScaleInput>) {
  const { id, ...rest } = data
  return restApiClient.url(constructApiUrl(API.staffPayScales.update.url, { id })).patch(rest)
}
